import { IAppState } from '../../redux';

export const selectCanPublishAsHomeowner = (state: IAppState): boolean => {
  return !!state.user.homeownerInfo?.canPublishAsHomeowner;
};
